// Portfolio home: the Location / Facility / Project Owner filters (applied with Common/Filter.js, filterArea
// "ProjectManagement", which keeps them in the URL as location / facility / projectOwner) and the KPI figures.

export const FILTER_KEYS = [
    { key: 'location', values: (p) => (p.location_name ? [p.location_name] : []) },
    { key: 'facility', values: (p) => [p.facility_name] },
    { key: 'projectOwner', values: (p) => p.owner_names || [] },
];

export const matchesFilters = (p, filters) => FILTER_KEYS.every(f => !filters[f.key] || f.values(p).includes(filters[f.key]));

// Choices for Filter.js (pmFilterOptions): every location, facility and owner across the projects
export const pmFilterOptions = (projects) => {
    const sorted = (key) => [...new Set(projects.flatMap(FILTER_KEYS.find(f => f.key === key).values))].sort((a, b) => a.localeCompare(b));
    return { locations: sorted('location'), facilities: sorted('facility'), projectOwners: sorted('projectOwner') };
};

// ₹ in lakhs, the way the team reads budgets (same format as the v69 design)
export const fmtInr = (n) => {
    const v = Number(n) || 0;
    return Math.abs(v) >= 1e5 ? `₹${(v / 1e5).toFixed(1)}L` : `₹${Math.round(v).toLocaleString('en-IN')}`;
};

export const portfolioKpis = (projects) => {
    const active = projects.filter(p => p.status !== 'Completed');
    const delayed = projects.filter(p => p.status === 'Delayed');
    const completed = projects.filter(p => p.status === 'Completed');
    const notStarted = active.filter(p => p.stage === 'Not started');
    // Budget figures cover every project in view that has a budget sheet (only sent to admins)
    const budgets = projects.map(p => p.budget).filter(Boolean);
    const revenue = budgets.reduce((s, b) => s + (b.revenue || 0), 0);
    const profit = budgets.reduce((s, b) => s + (b.profit || 0), 0);
    return {
        active: active.length,
        cities: new Set(active.map(p => p.location_name).filter(Boolean)).size,
        notStarted: notStarted.length,
        onSchedule: active.length - delayed.length,
        onSchedulePct: active.length ? Math.round(((active.length - delayed.length) / active.length) * 100) : 100,
        delayed,
        completed: completed.length,
        hasBudgets: budgets.length > 0,
        revenue,
        profit,
        margin: revenue > 0 ? Math.round((profit / revenue) * 100) : 0,
    };
};
